module.exports = __webpack_public_path__ + "static/pfmall-b23fb8f930720423f1a89961d277bb6b.jpeg";